<template>
  <div>
    <van-overlay
      :show="isShow"
      :custom-style="{
        background: 'rgb(0, 0, 0, 0.6)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      }"
    >
      <van-loading size="30px" color="#4994df">
        <span style="color:#4994df">{{ title || '加载中···' }}</span>
      </van-loading>
    </van-overlay>
  </div>
</template>

<script>
export default {
  name: 'loading'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/component/loading/loading.vue